/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GlobalStatsDto } from '../../models/global-stats-dto';

export interface SuperadminControllerGetGlobalStats$Params {
}

export function superadminControllerGetGlobalStats(http: HttpClient, rootUrl: string, params?: SuperadminControllerGetGlobalStats$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalStatsDto>> {
  const rb = new RequestBuilder(rootUrl, superadminControllerGetGlobalStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GlobalStatsDto>;
    })
  );
}

superadminControllerGetGlobalStats.PATH = '/superadmin/stats';
